import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

interface IConstant {
  [key: string]: any
}

class Constant extends Model<IConstant> {
  constructor(attr: IConstant = {}) {
    super(attr)
    makeObservable(this, {
      value: computed,
    })
  }

  static urlRoot() {
    return '/constants'
  }

  get value(): any | null | undefined {
    if (!this.has('value')) return null

    return this.attributes.value
  }
}

export default Constant
